"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueFromPath = exports.removeKnownKeysFromErrorDetail = exports.deleteProperty = exports.getStringMessage = exports.generateFieldErrorFromErrorDetail = exports.generateMessageFromStringArray = exports.getErrorDetail = void 0;
var dataStructureUtils_1 = require("./dataStructureUtils");
var stringUtils_1 = require("./stringUtils");
function getErrorDetail(errorInfo) {
    return errorInfo && typeof errorInfo.detail === "object"
        ? errorInfo.detail
        : null;
}
exports.getErrorDetail = getErrorDetail;
function generateMessageFromStringArray(array, key) {
    var message = array[0];
    return key ? key + ": " + message : message;
}
exports.generateMessageFromStringArray = generateMessageFromStringArray;
function generateFieldErrorFromErrorDetail(fieldName, errorDetail) {
    if (typeof fieldName !== "string") {
        throw new Error("fieldName can be string only");
    }
    var fieldError;
    var errorValue = getValueFromPath(errorDetail, fieldName);
    // errorValue can be string[], ExceptionDetail[], ExceptionDetail or undefined
    if (errorValue) {
        if (dataStructureUtils_1.isArrayOfStrings(errorValue)) {
            fieldError = errorValue;
        }
        else {
            var stringMessage = getStringMessage(errorValue);
            fieldError = stringMessage ? [stringMessage] : undefined;
        }
    }
    return fieldError;
}
exports.generateFieldErrorFromErrorDetail = generateFieldErrorFromErrorDetail;
function getStringMessage(errorDetailValue, options) {
    var message = "";
    if (Array.isArray(errorDetailValue)) {
        if (dataStructureUtils_1.isArrayOfStrings(errorDetailValue)) {
            // This is the exit condition of this recursion, string message can be generated now
            // errorDetailValue = ["", ""]
            message = generateMessageFromStringArray(errorDetailValue, generateErrorKeyToDisplay((options === null || options === void 0 ? void 0 : options.key) || "", options === null || options === void 0 ? void 0 : options.keyOptions));
        }
        else if (dataStructureUtils_1.isArrayOfObjects(errorDetailValue)) {
            // errorDetailValue = [ {}, {}, {..} ]
            var firstNonEmptyErrorObject = errorDetailValue.find(function (x) { return !dataStructureUtils_1.isObjectEmpty(x); });
            if (firstNonEmptyErrorObject) {
                message = getStringMessage(firstNonEmptyErrorObject, {
                    keyOptions: options === null || options === void 0 ? void 0 : options.keyOptions
                });
            }
        }
    }
    else if (typeof errorDetailValue === "object") {
        // errorDetailValue = {..} || {}
        var errorDetailKeys = Object.keys(errorDetailValue);
        if (errorDetailKeys.length) {
            // `non_field_errors` has priority
            if (errorDetailKeys.includes("non_field_errors") &&
                errorDetailValue.non_field_errors) {
                message = getStringMessage(errorDetailValue.non_field_errors, {
                    keyOptions: options === null || options === void 0 ? void 0 : options.keyOptions
                });
            }
            else {
                var defaultErrorKey = errorDetailKeys[0];
                // Start recursion again with the first key's value
                // `key` should be sent in case `errorDetailValue[defaultErrorKey]` is the recursion's exit value: string[]
                // `key` then can be processed according to `keyOptions`
                message = getStringMessage(errorDetailValue[defaultErrorKey], {
                    key: defaultErrorKey,
                    keyOptions: options === null || options === void 0 ? void 0 : options.keyOptions
                });
            }
        }
    }
    else {
        // If `errorDetailValue` is neither string[], ExceptionDetail[] nor ExceptionDetail
        message = JSON.stringify(errorDetailValue);
    }
    return message;
}
exports.getStringMessage = getStringMessage;
function generateErrorKeyToDisplay(defaultErrorKey, keyOptions) {
    var _a;
    var errorKey = defaultErrorKey;
    if (keyOptions === null || keyOptions === void 0 ? void 0 : keyOptions.shouldHideErrorKey) {
        errorKey = undefined;
    }
    else if ((_a = keyOptions === null || keyOptions === void 0 ? void 0 : keyOptions.fieldLabelMap) === null || _a === void 0 ? void 0 : _a[defaultErrorKey]) {
        errorKey = keyOptions.fieldLabelMap[defaultErrorKey];
    }
    if (errorKey && (keyOptions === null || keyOptions === void 0 ? void 0 : keyOptions.shouldCapitalizeErrorKey)) {
        errorKey = stringUtils_1.convertSnakeCaseToTitleCase(errorKey);
    }
    return errorKey;
}
function deleteProperty(exceptionDetail, path) {
    var filteredObj = __assign({}, exceptionDetail);
    var keys = path.split(".");
    keys.reduce(function (value, key, index) {
        if (value && !Array.isArray(value)) {
            if (index === keys.length - 1) {
                delete value[key];
            }
            return value[key];
        }
    }, filteredObj);
    return filteredObj;
}
exports.deleteProperty = deleteProperty;
function removeKnownKeysFromErrorDetail(errorDetail, knownErrorKeys) {
    if (knownErrorKeys && knownErrorKeys.length) {
        // delete all `knownErrorKeys` from errorDetail
        errorDetail = knownErrorKeys.reduce(deleteProperty, errorDetail);
    }
    return errorDetail;
}
exports.removeKnownKeysFromErrorDetail = removeKnownKeysFromErrorDetail;
function getValueFromPath(exceptionDetail, path) {
    var filteredObj = __assign({}, exceptionDetail);
    var keys = path.split(".");
    return keys.reduce(function (acc, key) {
        return acc && !Array.isArray(acc) ? acc[key] : undefined;
    }, filteredObj);
}
exports.getValueFromPath = getValueFromPath;
